module.exports = __webpack_public_path__ + "static/media/Yoga.8e96a0a9.png";